import React, { Component } from "react";
import { Modal, Button, Input, Table, TextArea } from "semantic-ui-react";
import { connect } from "react-redux";
import { parseString } from "xml2js";
import _ from "lodash";
import { expireSession, isTokenExpired } from "../../actions/auth";
import api from "../../api";
import settings from "../../settings";
import { loadUi } from "../../actions/search";
import { ERR_MSG_SESSION_EXPIRED } from "../../ErrorMessages";
import { setUserCases, removeUserCases } from "../../actions/userCases";
import {
  setUserCaseCharges,
  removeUserCaseCharges,
} from "../../actions/userCaseCharges";

class Case extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      updatedReportCostRecs: [],
      currentFolder: props.dialogProps.data,
      dialogProps: props.dialogProps,
      isNewCaseAdded: false,
    };
  }

  componentDidMount() {
    this.loadCaseCharges(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (
      !_.isEqual(nextProps.dialogProps, this.state.dialogProps) // ||
      // (this.state.reports && this.state.reports.length === 0)
    ) {
      this.loadCaseCharges(nextProps);
      if (this.isCompMounted) {
        this.setState({
          currentFolder: nextProps.dialogProps.data,
          dialogProps: nextProps.dialogProps,
        });
      }
    }
  }

  componentWillUnmount() {
    this.isCompMounted = false;
    if (this.state.isNewCaseAdded) this.props.loadUi();
  }

  onChange = (e) => {
    if (this.isCompMounted) {
      this.setState({
        currentFolder: {
          ...this.state.currentFolder,
          [e.target.name]: e.target.value,
        },
        error: undefined,
      });
    }
  };

  isCompMounted = false;

  reportCostChanged = (e, data, id) => {
    const updatedReportCostRecs = this.state.updatedReportCostRecs;
    updatedReportCostRecs[`rep_${id}`] = data.value;
    if (this.isCompMounted) {
      this.setState({ updatedReportCostRecs });
    }
  };

  loadCaseCharges = (props) => {
    this.isCompMounted = true;
    if (props.userCases) {
      if (this.isCompMounted) {
        this.setState({
          reports: props.userCases.reports,
          updatedReportCostRecs: props.userCases.updatedReportCostRecs,
        });
      }
      return;
    }
    const params = {
      view: "newcase",
      sserver: settings.appName,
      userID: props.user.userid,
      sessionID: localStorage.getItem("sessionID"),
    };
    if (isTokenExpired()) {
      expireSession();
      return;
    }
    api.lp
      .getActivitiesView(params)
      .then((res) => {
        if (res) {
          parseString(res.data, { async: false }, (err, result) => {
            if (result !== null && result !== undefined) {
              const root = Object.keys(result)[0];
              if (root === "errors") {
                if (
                  _.get(result, `${root}.error[0].$.errType`) === "unauthorized"
                ) {
                  localStorage.errorMessage = _.get(
                    result,
                    `${root}.error[0].errMsg[0]`,
                    ""
                  );
                  this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
                }
              } else {
                const reports = _.get(
                  result,
                  "searchMenu.soap:Envelope[0].soap:Body[0].GetUserSearchListExResponse[0].GetUserSearchListExResult[0].UserItems[0].Reports[0].row"
                );
                const updatedReportCostRecs = this.state.updatedReportCostRecs;
                const updatedReports = [];
                _.forEach(reports, (report) => {
                  report.intReportId = parseInt(report.ReportID, 10);
                  updatedReportCostRecs[`rep_${report.intReportId}`] =
                    report.SearchResultCost[0];
                  updatedReports.push(report);
                });
                const orderedReports = _.orderBy(
                  updatedReports,
                  ["ReportTypeDescription[0]", "intReportId"],
                  ["asc", "asc"]
                );
                const folders = [];
                _.forEach(_.get(result, "searchMenu.folder"), (folder) => {
                  folders.push({
                    folderCode: parseInt(folder.folderCode, 10),
                    folderName: folder.folderName[0],
                    comment: folder.comment[0],
                    actUpdateFormatted: folder.actUpdateFormatted[0],
                    dateofentry: folder.dateofentry[0],
                  });
                });
                props.setUserCases({
                  reports: orderedReports,
                  updatedReportCostRecs,
                  Folders: folders,
                });
                this.loadCaseCustomCharges(props);
              }
            }
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          props.expireSession();
        }
      });
  };

  loadCaseCustomCharges = (props) => {
    if (props.userCaseCharges) {
      if (this.isCompMounted) {
        this.setState({
          customFolderCosts: props.userCaseCharges.customFolderCosts,
        });
        return;
      }
    }
    const params = {
      sserver: settings.appName,
      userID: props.user.userid,
      sessionID: localStorage.getItem("sessionID"),
      fetchAll: true,
      folderIds: [],
    };
    if (isTokenExpired()) {
      expireSession();
      return;
    }
    api.lp
      .getCaseCostDetails(params)
      .then((res) => {
        props.setUserCaseCharges({
          customFolderCosts: res.data.Data,
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          props.expireSession();
        }
      });
  };

  submit = () => {
    const currentFolder = this.state.currentFolder;
    let folderCode = currentFolder.folderCode;
    if (parseInt(folderCode, 10) < 1) {
      folderCode = "";
    }
    const reportCosts = [];
    _.forEach(Object.keys(this.state.updatedReportCostRecs), (repId) => {
      reportCosts.push({
        reportId: repId.replace("rep_", ""),
        cost: this.state.updatedReportCostRecs[repId],
      });
    });
    if (isTokenExpired()) {
      expireSession(ERR_MSG_SESSION_EXPIRED);
      return;
    }
    api.lp
      .processCases({
        folderCode,
        folderName: currentFolder.folderName,
        comment: currentFolder.comment,
        reportCosts,
      })
      .then((res) => {
        if (res.data.Status === "Error") {
          if (this.isCompMounted) {
            this.setState({ error: "Unable to save case" });
          }
        } else {
          currentFolder.folderCode = res.data.FolderCode;
          this.props.removeUserCases();
          this.props.removeUserCaseCharges();
          this.props.updateCase(currentFolder);
          this.props.dialogClose(this);
          this.loadCaseCharges(this.props);
          this.loadCaseCustomCharges(this.props);
          localStorage.newFolderCode = currentFolder.folderCode;
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
        }
      });
  };

  render() {
    const rows = [];
    const reports = this.state.reports;
    if (reports && reports.length > 0) {
      let prevReportTypeDescription;
      let customReportCosts = [];
      if (
        this.state.currentFolder !== null &&
        this.state.currentFolder !== undefined &&
        this.state.currentFolder.folderCode !== null &&
        this.state.currentFolder.folderCode !== undefined &&
        this.state.customFolderCosts &&
        this.state.customFolderCosts.length > 0
      ) {
        customReportCosts = this.state.customFolderCosts[
          this.state.currentFolder.folderCode
        ];
      }

      _.forEach(reports, (report, index) => {
        const customReportCost = _.find(
          customReportCosts,
          (crc) => crc.reportId === report.ReportID[0]
        );
        if (
          prevReportTypeDescription === undefined ||
          report.ReportTypeDescription[0] !== prevReportTypeDescription
        ) {
          rows.push(
            <Table.Row key={`case_rep_${index}_header`}>
              <Table.Cell colSpan={6} className="report-sub-section-header">
                {report.ReportTypeDescription[0].toUpperCase()}
              </Table.Cell>
            </Table.Row>
          );
          prevReportTypeDescription = report.ReportTypeDescription[0];
        }
        rows.push(
          <Table.Row key={`case_rep_${index}`}>
            <Table.Cell />
            <Table.Cell>{`${report.ReportLabel[0]} ${
              !report.ReportLabel[0].includes("Report") &&
              !report.ReportLabel[0].includes("Search")
                ? "Search"
                : ""
            } ${
              report.NumberAtCost[0] === 0
                ? `( first ${report.NumberAtCost[0]} )`
                : ""
            }`}</Table.Cell>
            <Table.Cell>{report.SearchResultCost[0]}</Table.Cell>
            <Table.Cell>{report.SearchNoResultCost[0]}</Table.Cell>
            <Table.Cell>{report.SearchResultCost[0]}</Table.Cell>
            <Table.Cell>
              <Input
                id={report.ReportID[0]}
                defaultValue={
                  customReportCost !== undefined
                    ? customReportCost.cost
                    : report.SearchResultCost[0]
                }
                onChange={(e, data) =>
                  this.reportCostChanged(e, data, report.ReportID[0])
                }
              />
            </Table.Cell>
          </Table.Row>
        );
      });
    }
    return (
      <Modal
        className={"dialog-render"}
        // size={"tiny"}
        // trigger={
        // this.props.source
        // <Button style={{ backgroundColor: "none" }}>Coverage</Button>
        // }
        closeIcon
        open={this.props.active}
        onClose={() => this.props.dialogClose(this)}
      >
        <Modal.Header className="report-name-header">
          {/* {this.state.currentFolder !== null &&
          this.state.currentFolder.folderName !== null
            ? `Edit Case: ${this.state.currentFolder.folderName}`
            : "New Case"} */}
          {this.props.dialogProps.title !== "New Case"
            ? `Edit Case: ${this.props.dialogProps.title}`
            : this.props.dialogProps.title}
        </Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            <Table>
              <Table.Body>
                {this.state.error && (
                  <Table.Row>
                    <Table.Cell width={16} className={"red-text"}>
                      {this.state.error}
                    </Table.Cell>
                  </Table.Row>
                )}
                <Table.Row>
                  <Table.Cell
                    width={4}
                    className="text-bold table-border-right-line"
                  >
                    Case Name:
                  </Table.Cell>
                  <Table.Cell width={12}>
                    <Input
                      key="case_Name"
                      type="text"
                      name={"folderName"}
                      placeholder={"Case Name"}
                      onChange={this.onChange}
                      defaultValue={
                        this.state.currentFolder !== null &&
                        this.state.currentFolder.folderName !== null
                          ? this.state.currentFolder.folderName
                          : ""
                      }
                    />
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell
                    width={4}
                    className="text-bold table-border-right-line"
                  >
                    Comments:
                  </Table.Cell>
                  <Table.Cell width={12}>
                    <TextArea
                      key="case_Comment"
                      name={"comment"}
                      placeholder={"Comment"}
                      onChange={this.onChange}
                      defaultValue={
                        this.state.currentFolder !== null &&
                        this.state.currentFolder.comment !== null
                          ? this.state.currentFolder.comment
                          : ""
                      }
                      className={"case-comment"}
                      rows={2}
                    />
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <Table>
              <Table.Body>
                <Table.Row className="report-section-header">
                  <Table.HeaderCell width={2}>Type</Table.HeaderCell>
                  <Table.HeaderCell width={4}>Service</Table.HeaderCell>
                  <Table.HeaderCell width={3}>
                    Service Charge - Hit
                  </Table.HeaderCell>
                  <Table.HeaderCell width={3}>
                    Service Charge - No Hit
                  </Table.HeaderCell>
                  <Table.HeaderCell width={2}>My Charge</Table.HeaderCell>
                  <Table.HeaderCell width={2}>This Case</Table.HeaderCell>
                </Table.Row>
                {rows}
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions className={"dialog-actions"}>
          <div className={"float-right"}>
            <Button primary onClick={() => this.submit()}>
              {this.props.dialogProps.title === "New Case"
                ? "Create"
                : "Submit"}
            </Button>
            <Button
              className={"no-background-color"}
              onClick={() => this.props.dialogClose(this)}
            >
              Cancel
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    userCases:
      state.userCases && state.userCases.userCases
        ? state.userCases.userCases
        : undefined,
    userCaseCharges:
      state.userCaseCharges && state.userCaseCharges.userCaseCharges
        ? state.userCaseCharges.userCaseCharges
        : undefined,
  };
}
export default connect(mapStateToProps, {
  loadUi,
  expireSession,
  setUserCases,
  setUserCaseCharges,
  removeUserCases,
  removeUserCaseCharges,
})(Case);



// WEBPACK FOOTER //
// ./src/components/dialogs/Case.js